export enum ActionType {
    ISLOADING = 'isLoading',
    ISLOADED = 'isLoaded',
    ISSUCCESS = 'isSuccess',
    ISFORMVISIBLE = 'isFormVisible',
    ISFAILURE = 'isFailure',
    VALIDATE = 'isValidate',
    ISEMAILPREFERENCE ='isEmailPreference',
}

export default ActionType;
